import { createTheme } from '@mui/material'

export const breakPoints = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920,
}

export const colors = {
  // Backgrounds
  BG100: '#FFFFFF', // White
  BG200: '#FEFEFE', // Header
  BG250: '#FBFBFC',
  BG300: '#F8F8FA', // Background
  BG400: '#F1F0F5', // Dark setion

  // Texts
  INK300: '#DDD',    // Disabled button background
  INK400: '#C4BFCF', // Sections
  INK500: '#A8A1B0', // Body light and labels
  INK600: '#CCC',
  INK900: '#46424A', // Headers and body

  // Buttons and borders
  PRI800: '#A74C75', // Text buttons
  PRI900: '#8C3C60', // Rect buttons gradient colour 1

  // Card statuses
  LILAC400: '#D8D0E8', // Statuses
  RED400: '#DE838C',
  GREEN400: '#95C1B6',

  PURPLE900: '#403752',
  PURPLE950: '#30293d',

  CARD_SHADOW: '#653ED310',

  // Destructive buttons
  RED700: '#C56E6E', // Destructive buttons

  // Tag colors
  RED800: '#DF6060',
  GREEN800: '#7AC07C',
  BLUE800: '#7189C6',
  ORANGE800: '#DF7357',
}

// This is needed in order to access internal MUI variables (i.e. spacing)
const defaultTheme = createTheme(
  {
    spacing: 6,
  },
)

export const theme = createTheme({
  spacing: defaultTheme.spacing,
  shape: {
    borderRadius: defaultTheme.spacing(4),
  },
  typography: {
    fontFamily: 'Muli, sans-serif',
    h1: {
      fontFamily: 'quiche-sans',
      color: colors.INK900,
      fontWeight: 500,
    },
    h2: {
      fontFamily: 'quiche-sans',
      color: colors.INK900,
      fontWeight: 500,
    },
    h3: {
      fontFamily: 'quiche-sans',
      color: colors.INK900,
      fontWeight: 500,
      fontSize: '2.2rem',
    },
    h4: {
      fontFamily: 'quiche-sans',
      color: colors.INK900,
      fontSize: '1.5rem',
      lineHeight: 1.24,
      fontWeight: 500,
    },
    h5: {
      fontFamily: 'quiche-sans',
      color: colors.INK900,
      fontSize: '1.25rem',
      lineHeight: 1,
      fontWeight: 400,
    },
    subtitle1: {
      fontWeight: 200,
      fontSize: '1.1rem',
      color: colors.INK900,
    },
    subtitle2: {
      fontWeight: 600,
      fontSize: '1.1rem',
      color: colors.INK900,
    },
    body1: {
      fontSize: '1rem',
      fontWeight: 200,
      lineHeight: 1.6,
      color: colors.INK900,
    },
    body2: {
      fontWeight: 700,
      fontSize: '1rem',
      lineHeight: 1.6,
      color: colors.INK900,
    },
    caption: {
      fontSize: '0.9rem',
      fontWeight: 200,
      lineHeight: 1.35,
      color: colors.INK500,
    },
    overline: {
      fontSize: '0.75rem',
      fontWeight: 600,
      letterSpacing: 0.5,
      color: colors.INK400,
    },
  },
  palette: {
    primary: {
      main: colors.PRI900,
    },
    secondary: {
      main: colors.LILAC400,
    },
  },
})

export type Colors = typeof colors
export type Breakpoints = typeof breakPoints